import React from "react";
import DOMPurify from "dompurify";
import "../index.css";

const ContentBelowHeroBanner = ({ data, center = false }) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(data?.add_content || ""),
      }}
    ></div>
  );
};

export default ContentBelowHeroBanner;
